import React from 'react';
import { Icon } from './Icon.js';
export const IconWindowCenterFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M9.25 1C10.7688 1 12 2.23122 12 3.75V8.25C12 9.76878 10.7688 11 9.25 11H2.75C1.23122 11 0 9.76878 0 8.25V3.75C0 2.23122 1.23122 1 2.75 1H9.25ZM5 4.25C4.58579 4.25 4.25 4.58579 4.25 5V7C4.25 7.41421 4.58579 7.75 5 7.75H7C7.41421 7.75 7.75 7.41421 7.75 7V5C7.75 4.58579 7.41421 4.25 7 4.25H5Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconWindowCenterFill12.js.map